import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Tabs,
  Tab,
  Form,
  Stack,
  InputGroup,
  FormControl,
} from 'react-bootstrap';
import classes from './signInModal.module.scss';
import { Icon, CountDown, Button } from 'lb-components';
import { EyeIcon, EyeSlashIcon } from '../../../assets/icons';
import { Hook, Toast, useTranslation } from 'lb-store';
import { UseRegister, UseRecovery, UseSignIn, UseUser, UsePhoneVerification } from 'lb-store/src/hooks';
import Config from 'lb-store/src/config/config';


export const SignInModal = ({ onCancel, onSuccess, ...props }) => {
  const { t } = useTranslation();
  const registerModal = UseRegister();
  const recoveryModal = UseRecovery();
  const signInModal = UseSignIn();
  const refCode = useRef();
  const alert = Hook.UseAlert();
  const { keepAlive } = UseUser();
  const phoneVerification = UsePhoneVerification();
  /*UseGuest*/
  const guest = Hook.UseGuest();

  /*ცვლადები*/
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [smsCode, setSmsCode] = useState('');
  const [securityCode, setSecurityCode] = useState('');

  /*  დამატებითი ცვლადები*/
  const [showPassword, setShowPassword] = useState(false);
  const [showSecurityCode, setShowSecurityCode] = useState(false);
  const [captchaCounter, setCaptchaCounter] = useState(0)
  const [showSmsCode, setShowSmsCode] = useState(false);
  const [resend, setResend] = useState(false);
  const [timer, setTimer] = useState(0);

  /*შეცდომები*/
  const [errors, setErrors] = useState({
    username: '',
    password: '',
    smsCode: '',
    securityCode: '',
  });
  const signIn = (sendSmsCode = true) => {
    let params = {
      user: username,
      pass: password,
    };
    if (showSecurityCode) {
      params = { ...params, captcha: securityCode };
    }
    if (showSmsCode && sendSmsCode) {
      params = { ...params, sms_code: smsCode };
    }

    params = { ...params, reactive: true };
    guest.SignIn({
      data: params,
      onSuccess: () => {
        keepAlive().then((res) => {
          if(onSuccess) onSuccess(res);


          if (res?.data?.mobile_verified === "no") {
            phoneVerification.open({
              onSuccess: () => {
                alert.open({ message: t('თქვენი ნომერი ვერიფიცირებულია') });              },
            });
          }
        });

        onCancel('success');
      },
      onError: (error) => {
        if (error?.code) {
          switch (error?.code) {
            case 'captcha':
              setShowSecurityCode(true);
              break;
            case 'sms':
              setShowSecurityCode(false)
              setTimer(error?.left);
              setShowSmsCode(true);
              if (!sendSmsCode) {
                setResend(true);
              }
              setErrors({ ...errors, smsCode: t(error?.desc) });

               setTimeout(()=>{
                  if(refCode.current){
                    //console.log("focus")
                    refCode.current.focus()
                  }
               },100)

              break;
            default:
              alert.open({ message: t(error?.desc) });
          }
        } else {
          alert.open({
            message: t(error?.desc),
            /*onCancel: () => alert('ok'),*/
          });
          if(showSecurityCode){
            setSecurityCode('')
            setCaptchaCounter(captchaCounter + 1)
          }
        }
      },
    });
  };
  return (
    <Modal
      contentClassName={classes.signInModal}
      onHide={onCancel}
      {...props}
      draggable
    >
      <Modal.Header closeButton className={classes.header}>
        <Modal.Title className={classes.title}>{t('ავტორიზაცია')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Form
          className={classes.form}
          onSubmit={(e) => {
            e.preventDefault();
            signIn();
          }}
        >
          <Form.Group className={classes.formGroup}>
            <Form.Label htmlFor ="username">{t('მომხმარებელი')}</Form.Label>
            <Form.Control
              isInvalid={errors.username !== ''}
              value={username}
              name="username"
              id="username"
              onChange={(e) => {
                setUsername(e.target.value);
                setErrors({ ...errors, username: '' });
              }}
            />
            <Form.Control.Feedback type='invalid'>
              {errors['username']}
            </Form.Control.Feedback>
            <Button
              tabIndex={-1}
              variant={'link'}
              onClick={() => {
                recoveryModal.open({
                  initialTab: 'username',
                });
                onCancel();
              }}
            >
              {t('აღდგენა')}
            </Button>
          </Form.Group>
          <Form.Group className={classes.formGroup}>
            <Form.Label  htmlFor ="password">{t('პაროლი')}</Form.Label>
            <div
              style={{
                flex: 1,
                display: 'flex',
                position: 'relative',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Form.Control
                name="password"
                id="password"
                type={!showPassword ? 'password' : 'text'}
                isInvalid={errors.password !== ''}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors({ ...errors, password: '' });
                }}
              />
              <Icon
                style={{
                  position: 'absolute',
                  right: '25px',
                }}
                Icon={!showPassword ? EyeSlashIcon : EyeIcon}
                height='20px'
                native
                width='20px'
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <div style={{ color: 'red', fontSize: '0.875em' }}>
              {errors.password}
            </div>
            <Button
              tabIndex={-1}
              variant={'link'}
              onClick={() => {
                recoveryModal.open({
                  initialTab: 'password',
                  onSuccess: () => {
                    signInModal.open({});
                  },
                });
                onCancel();
              }}
            >
              {t('აღდგენა')}
            </Button>
          </Form.Group>
          {showSmsCode && (
            <>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t("სმს კოდი")}</Form.Label>
                <div style={{ position: 'relative' }}>
                  <Form.Control
                    ref={refCode}
                    type={'number'}
                    isInvalid={errors.smsCode !== ''}
                    value={smsCode}

                    autoComplete={'one-time-code'}
                    onChange={(e) => {
                      setSmsCode(e.target.value);
                      setErrors({ ...errors, smsCode: '' });
                    }}
                  />

                  {resend && (
                    <div
                      style={{
                        position: 'absolute',
                        right: 2,
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }}
                    >
                      <CountDown
                        onComplete={() => {
                          setResend(false);
                          setErrors({ ...errors, smsCode: '' });
                        }}
                        Duration={timer}
                        Colors={['#ffca2c']}
                        ColorsTime={[0]}
                        BackgroundColor={'#373940'}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    {!resend && (
                      <Form.Label
                        style={{ textDecoration: 'underline' }}
                        onClick={() => {
                          signIn(false);
                          setTimeout(()=>{
                            console.log(refCode)
                            if(refCode.current){
                              refCode.current.focus()
                            }
                          },100)
                          setSmsCode('');
                          setErrors({ ...errors, smsCode: '' });
                        }}
                      >
                        {t('თავიდან გაგზავნა')}
                      </Form.Label>
                    )}
                  </div>
                  <div style={{ color: 'red', fontSize: '0.875em' }}>
                    {errors.smsCode}
                  </div>
                </div>
              </Form.Group>
            </>
          )}

          {showSecurityCode && (
            <Form.Group className={classes.formGroup}>
              <Form.Label>{t('დამცავი კოდი')}</Form.Label>
              <Stack
                direction={'horizontal'}
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                }}
                gap={1}
              >
                <div
                  style={{
                    maxWidth: '50%',
                    width: '100px',
                    marginBottom: errors.securityCode !== '' ? '2rem' : 0,
                    display: 'flex',
                    backgroundColor: '#424242',
                  }}
                >
                  <img
                    src={`${Config.Captcha}${captchaCounter}`}
                    style={{ width: '100%' }}
                    alt='captcha'
                    onClick={() => setCaptchaCounter(captchaCounter + 1)}
                  />
                </div>
                <Stack
                  direction={'vertical'}
                  style={{
                    display: 'flex',
                    alignItems: 'stretch',
                  }}
                  gap={1}
                >
                  <Form.Control
                    type={'number'}
                    style={{ flex: 1 }}
                    isInvalid={errors.securityCode !== ''}
                    value={securityCode}
                    onChange={(e) => {
                      setSecurityCode(e.target.value);
                      setErrors({ ...errors, securityCode: '' });
                    }}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.securityCode}
                  </Form.Control.Feedback>
                </Stack>
              </Stack>
            </Form.Group>
          )}

          <div className={classes.buttonsContainer}>
            <Button
              variant={'primary'}
              type={'submit'}
              style={{ marginBottom: '0.8rem', padding: '0.8rem 1rem' }}
            >
              {t('შესვლა')}
            </Button>
            <Button
              variant={'link'}
              onClick={() => {
                registerModal.open({
                  onSuccess: () => {
                    Toast.show({
                      content: t('თქვენ წარმატებით გაიარეთ რეგისტრაცია'),
                    });
                  },
                });
                onCancel();
              }}
            >
              {t('რეგისტრაცია')}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

SignInModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  onCancel: PropTypes.func,
};
SignInModal.defaultProps = {
  show: true,
  centered: true,
};
